import React, { ReactNode, createContext, useContext, useState } from 'react';
import { assertIsDefined } from '@/helpers/assertions';

export interface IDashboardTourStep {
  target: string;
  content: ReactNode;
}

interface IDashboardTourContext {
  steps: IDashboardTourStep[];
  setSteps: (steps: IDashboardTourStep[]) => void;
  isTourActive: boolean;
  setTourActive: (active: boolean) => void;
}

const DashboardTourContext = createContext<Partial<IDashboardTourContext>>({});

export const DashboardTourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [steps, setSteps] = useState<IDashboardTourStep[]>([]);
  const [isTourActive, setTourActive] = useState(false);

  return (
    <DashboardTourContext.Provider value={{ steps, setSteps, isTourActive, setTourActive }}>
      {children}
    </DashboardTourContext.Provider>
  );
};

export const useDashboardTour = () => {
  const { isTourActive, setTourActive, setSteps, steps } = useContext(DashboardTourContext);

  assertIsDefined(isTourActive, '"IDashboardTourContext.isTourActive has to be defined!"');
  assertIsDefined(setTourActive, '"IDashboardTourContext.setTourActive has to be defined!"');
  assertIsDefined(setSteps, '"IDashboardTourContext.setSteps has to be defined!"');
  assertIsDefined(steps, '"IDashboardTourContext.steps has to be defined!"');

  return { isTourActive, setTourActive, setSteps, steps };
};
